module.exports = __webpack_public_path__ + "img/icon-03.9869038c.png";